export const RESOURCE_URL = "https://mindforce.s3.ap-south-1.amazonaws.com";
